<template>
  <div class="news_detail">
    <div class="news_title">零壹比特：以运动为翼，追逐职场新高度</div>
    <div class="news_date">2023.07.25</div>
    <div class="line"></div>
    <div class="news_content">
      <p>
        在杭州这片充满创新活力的互联网热土上，零壹比特公司不仅以技术创新为核心竞争力，更致力于为员工打造健康与成长并重的工作环境。近期公司新配备了专业的健身房，则是零壹比特重视员工Work
        Life Balance的一个缩影。
      </p>
      <img
        src="../../assets/images/news/sports/pic0.webp"
        alt="skiing picture"
      />
      <p>
        零壹比特的健身房占地超100平米，器械配置专业齐全。有氧区2台国际品牌跑步机、椭圆机及动感单车，支持心率监测与运动数据记录；力量训练区全套哑铃、杠铃，搭配龙门架等设备，满足不同训练需求；球类运动区，公司还有乒乓球、台球等多类场地。零壹比特的小伙伴们自发组织健身、球类社团，在攻防之间践行坚持的意义，器械上的使用痕迹在诉说着零壹比特的每位小伙伴对自律的执着与热爱。
      </p>
      <img
        src="../../assets/images/news/sports/pic1.png"
        alt="skiing picture"
      />
      <p>
        无论你是技术领域的探索者，还是创新方向的开拓者，杭州零壹比特科技公司都虚位以待。在这里，你能收获专业成长，也能拥抱健康生活，实现真正意义上的工作与生活平衡。加入我们，开启事业与生活的全新旅程！ 
      </p>
      <img
        src="../../assets/images/news/sports/pic2.webp"
        alt="skiing picture"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsSkiing',
}
</script>

<style scoped lang="less">
.news_detail {
  max-width: 8rem;
  margin: 0 auto;
  padding: 1.4rem 0.2rem 1.2rem 0.2rem;
  background: #fff;
}
.news_title {
  color: #43444e;
  font-size: 0.4rem;
  font-weight: 600;
  line-height: 0.6rem;
  margin-top: 0.4rem;
  margin-bottom: 0.2rem;
}

.news_date {
  font-size: 0.16rem;
  margin-bottom: 0.22rem;
  color: #43444e;
  font-size: 0.16rem;
  line-height: 0.34rem;
  opacity: 0.5;
}

.line {
  height: 1px;
  width: 100%;
  background: #d9d9d9;
  margin-bottom: 0.2rem;
}

.news_content {
  color: #43444e;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.24rem; /* 150% */
}
.news_content p {
  margin: 0.2rem 0;
}
.news_img {
  display: block;
  width: 100%;
  border-radius: 0.08rem;
  margin: 0.22rem 0;
  object-fit: cover;
}
.main_img {
  height: 2.2rem;
  object-position: center top;
}
.news_img_grid {
  display: flex;
  gap: 0.12rem;
  margin: 0.18rem 0;
}
.news_img_grid img {
  flex: 1;
  border-radius: 0.08rem;
  object-fit: cover;
  height: 1.2rem;
}
.grid2 img {
  height: 1.6rem;
}
.grid3 img {
  height: 1.1rem;
}
.grid4 img {
  height: 0.9rem;
}
@media (max-width: 700px) {
  .news_detail {
    max-width: 100vw;
    padding: 0.18rem 0.12rem 0.6rem 0.12rem;
  }
  .news_title {
    font-size: 0.18rem;
  }
  .news_content {
    font-size: 0.14rem;
  }
  .main_img {
    height: 1.2rem;
  }
  .news_img_grid img {
    height: 0.7rem;
  }
  .grid2 img {
    height: 1rem;
  }
  .grid3 img {
    height: 0.7rem;
  }
  .grid4 img {
    height: 0.5rem;
  }
}
</style>
